// extracted by mini-css-extract-plugin
export default {"paddingWrapper":"routing_paddingWrapper__46O+h"};